// extracted by mini-css-extract-plugin
export default {"buttonMobile":"buttonMobile_hM4dE","buttonDesktop":"buttonDesktop_XQt7w"};